import { CONSTANTS__client } from '@/constants/CONSTANTS__client';
import { store } from '@/state/store';
import { local_words_translating_in_progress_add } from '@/state/words/translate_from_english/local_words_translating_in_progress_add';
import { DTO_REQUEST__tokens_add } from '@shared/common/_requests/DTO_REQUEST__tokens_add';
import { CONSTANTS_GENERATION__value_range } from '@shared/constants/CONSTANTS_GENERATION__value_range';
import { DTO__word_with_context } from '@shared/dto/+word/word_translated/DTO__word_with_context';
import { FIELD__token } from '@shared/dto/generation/graph_invoke/_fields/token/FIELD__token';
import { DTO__token } from '@shared/dto/generation/settings/token/DTO__token';
import { DTO__token_range } from '@shared/dto/generation/settings/token/DTO__token_range';
import { DTOTokenCreateData } from '@shared/dto/generation/settings/token/dto_token_create_data';
import { ENUM__language_type } from '@shared/enums/ENUM__language_type';

export function for_token_add_create_request(entity_id: string) {
  let { user_settings } = store.getState().slice_user;
  let token_language = user_settings.regional_use_english_tokens_in_prompt ? ENUM__language_type.ENGLISH : user_settings.regional_language;

  let out = new DTO_REQUEST__tokens_add();
  out.entity_id = entity_id;

  out.token_language = token_language;
  out.user_language = user_settings.regional_language;

  return out;
}

export function for_token_add_create_word_with_context(word: string, weight: number, existing_tokens: DTO__token[], is_positive: boolean) {
  let { user_settings } = store.getState().slice_user;
  let token_language = user_settings.regional_use_english_tokens_in_prompt ? ENUM__language_type.ENGLISH : user_settings.regional_language;

  let out = new DTOTokenCreateData();
  out.is_positive = is_positive;
  out.weight = weight;

  let word_with_context = new DTO__word_with_context();
  word_with_context.word = word;
  word_with_context.context = existing_tokens.map(token_saved =>
    token_language == ENUM__language_type.ENGLISH ? token_saved.word_english : token_saved.word.word_translated,
  );

  out.word_with_context = word_with_context;

  if (user_settings.regional_language == ENUM__language_type.ENGLISH) {
    //do nothing
  } else if (token_language == ENUM__language_type.ENGLISH) {
    add_word_to_translate_from_english(user_settings.regional_language, word_with_context.word);
  } else {
    add_word_to_translate_from_native_language(token_language, word_with_context.word);
  }

  return out;
}

const add_word_to_translate_from_english = (user_language: string, word_english: string) => {
  store.dispatch(local_words_translating_in_progress_add({ language: user_language, words: [word_english] }));
};

const add_word_to_translate_from_native_language = (token_language: string, word_translated: string) => {
  store.dispatch(local_words_translating_in_progress_add({ language: token_language, words: [word_translated] }));
};

export function get_token_style_color(token: FIELD__token): string {
  let out = '';

  let weight_range = CONSTANTS_GENERATION__value_range.WEIGHT_ALLOWED;

  let weight_percentage = token.weight.get_value() - weight_range.min / (weight_range.max - weight_range.min);

  out = token.is_positive.get_value()
    ? CONSTANTS__client.TOKEN_COLOR_POSITIVE.get_value(weight_percentage)
    : CONSTANTS__client.TOKEN_COLOR_NEGATIVE.get_value(weight_percentage);

  return out;
}

export function get_token_range_style(tokenRange: DTO__token_range, is_positive: boolean): string {
  let out = '';

  let weight_range = CONSTANTS_GENERATION__value_range.WEIGHT_ALLOWED;

  let weight_percentage = ((tokenRange.weights.min + tokenRange.weights.max) / 2 - weight_range.min) / (weight_range.max - weight_range.min);

  out = is_positive ? CONSTANTS__client.TOKEN_COLOR_POSITIVE.get_value(weight_percentage) : CONSTANTS__client.TOKEN_COLOR_NEGATIVE.get_value(weight_percentage);

  return out;
}

export function getTokenClassName(token: DTO__token): string {
  let out = '';

  if (token.is_hidden) {
    out += ' opacity-50';
  }

  return out;
}
